/* Special Ava PDP: scroll-reveal animations. */
(function () {
  var script = document.currentScript;
  var sectionId = script && script.getAttribute('data-section-id');
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var container = document.getElementById('ab-ava-redesign-variant') || document.querySelector('main');
    if (!container) return;
    var mainSection = sectionId ? document.getElementById('shopify-section-' + sectionId) : null;

    /* Remove the classes once revealed so no transform lingers (it would break fixed-position modals inside). */
    function reveal(el, delay) {
      if (delay) el.style.transitionDelay = delay + 'ms';
      el.classList.add('ava-aos--in');
      var done = false;
      function cleanup() {
        if (done) return;
        done = true;
        el.classList.remove('ava-aos', 'ava-aos--card', 'ava-aos--in');
        el.style.transitionDelay = '';
      }
      el.addEventListener('transitionend', function (e) {
        if (e.target === el && e.propertyName === 'opacity') cleanup();
      });
      setTimeout(cleanup, 1400 + (delay || 0));
    }

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        sectionObserver.unobserve(entry.target);
        reveal(entry.target, 0);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });

    /* Cards: viewport root also respects the slider's overflow clip, so off-screen slides wait until swiped in. */
    var cardObserver = new IntersectionObserver(function (entries) {
      var visible = entries.filter(function (entry) { return entry.isIntersecting; });
      visible.sort(function (a, b) { return a.boundingClientRect.left - b.boundingClientRect.left; });
      visible.forEach(function (entry, i) {
        cardObserver.unobserve(entry.target);
        reveal(entry.target, i * 90);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.2 });

    function watch(el) {
      el.classList.add('ava-aos');
      sectionObserver.observe(el);
    }

    function watchCard(card) {
      if (card.dataset.avaAos) return;
      card.dataset.avaAos = '1';
      card.classList.add('ava-aos', 'ava-aos--card');
      cardObserver.observe(card);
    }

    if (mainSection) {
      mainSection.querySelectorAll('.product-pdp__trust, .product-pdp__col-media-bottom').forEach(watch);
    }
    container.querySelectorAll(':scope > .shopify-section').forEach(function (section) {
      if (section === mainSection) return;
      Array.prototype.forEach.call(section.children, function (child) {
        if (/^(STYLE|SCRIPT|LINK|TEMPLATE|NOSCRIPT)$/.test(child.tagName)) return;
        if (child.classList.contains('ava-redesign-eta-host')) return;
        watch(child);
      });
    });

    container.querySelectorAll('[data-rv-track]').forEach(function (track) {
      function scan() {
        track.querySelectorAll(':scope > .swiper-slide').forEach(watchCard);
      }
      scan();
      new MutationObserver(scan).observe(track, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
